import { render, staticRenderFns } from "./ProjectInvite.vue?vue&type=template&id=8f35f64a&scoped=true&"
import script from "./ProjectInvite.vue?vue&type=script&lang=ts&"
export * from "./ProjectInvite.vue?vue&type=script&lang=ts&"
import style0 from "./ProjectInvite.vue?vue&type=style&index=0&id=8f35f64a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f35f64a",
  null
  
)

export default component.exports